var _style, _defs, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path2, _path3, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "347.2px",
    height: "99.9px",
    viewBox: "0 0 347.2 99.9",
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 347.2 99.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n\t.st14{fill:url(#SVGID_15_);}\n\t.st15{fill:url(#SVGID_16_);}\n\t.st16{fill:url(#SVGID_17_);}\n\t.st17{fill:url(#SVGID_18_);}\n\t.st18{fill:url(#SVGID_19_);}\n\t.st19{fill:url(#SVGID_20_);}\n\t.st20{fill:url(#SVGID_21_);}\n\t.st21{fill:url(#SVGID_22_);}\n\t.st22{fill:url(#SVGID_23_);}\n\t.st23{fill:url(#SVGID_24_);}\n\t.st24{fill:url(#SVGID_25_);}\n\t.st25{fill:url(#SVGID_26_);}\n\t.st26{fill:url(#SVGID_27_);}\n\t.st27{fill:url(#SVGID_28_);}\n\t.st28{fill:url(#SVGID_29_);}\n\t.st29{fill:url(#SVGID_30_);}\n\t.st30{fill:url(#SVGID_31_);}\n\t.st31{fill:url(#SVGID_32_);}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.5515,
    y1: 70.9837,
    x2: 40.3157,
    y2: 70.9837
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.7,47.7c-3.4-3.1-7.8-4.6-13.3-4.6l-5.9,0.1V43H5.6l9.3,10.2h7.2c2.6,0,4.7,0.7,6.4,2.1 c1.6,1.3,2.3,2.9,2.1,4.7c-0.1,1.2-0.6,2.3-1.4,3.4c-0.9,1.1-2.1,2-3.6,2.6c-1.5,0.7-3.1,1-4.9,1h-6l-0.9,10h2.9l10.7,21.9h12.4 L28.3,75.3c3.1-1.3,5.8-3.4,7.9-6c2.4-2.9,3.7-6.2,4.1-9.7l0,0C40.6,54.8,39.1,50.8,35.7,47.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 73.9205,
    x2: 13.0634,
    y2: 73.9205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2.9,65.9 0,98.7 9.7,98.7 12.3,68.1 12.5,66.1 13.1,58.8 4.4,49.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.0663,
    y1: 64.3608,
    x2: 87.729,
    y2: 64.3608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "50.3,43.4 51.7,44.8 49.9,66.7 49.2,74.2 49.1,75.7 57.8,85.4 58.7,75.3 68.8,75.3 69.6,65.7  59.5,65.7 60.6,52.9 87.7,52.9 85.1,43.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.0097,
    y1: 89.8005,
    x2: 83.6661,
    y2: 89.8005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "56.9,89.5 48.6,80.5 47,99.1 83.7,99.1 81,89.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.3725,
    y1: 71.2517,
    x2: 134.2644,
    y2: 71.2517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "121.3,81.2 104,45.8 103.3,44.3 103.3,43.4 94.8,43.4 94.3,50 92.4,71.1 101.2,80.8 102.3,66.9  118.1,99.1 129.4,99.1 134.3,43.4 124.7,43.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.9402,
    y1: 87.4997,
    x2: 100.7062,
    y2: 87.4997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "89.9,99.1 99.5,99.1 100.7,85.5 91.9,75.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.2871,
    y1: 71.2517,
    x2: 181.1789,
    y2: 71.2517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "168.2,81.2 150.9,45.8 150.2,44.3 150.2,43.4 141.7,43.4 141.2,50 139.3,71.1 148.1,80.8 149.3,66.9  165,99.1 176.3,99.1 181.2,43.4 171.6,43.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.8547,
    y1: 87.4997,
    x2: 147.6207,
    y2: 87.4997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "136.9,99.1 146.4,99.1 147.6,85.5 138.8,75.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.521,
    y1: 76.3135,
    x2: 229.2009,
    y2: 76.3135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M221.8,85.8c-3.1,1.9-6.4,2.9-9.9,2.9c-4.9,0-8.8-1.7-11.9-5.1c-3.1-3.4-4.4-7.5-4-12.3 c0.3-3.5,1.5-6.7,3.7-9.7l0.5-0.7l-6.7-7.4l-0.8,0.9c-4.2,4.9-6.5,10.6-7.1,16.7c-0.4,5,0.4,9.7,2.5,14c2.1,4.3,5.2,7.7,9.3,10.2 c4.1,2.5,8.7,3.8,13.7,3.8c6.1,0,11.9-1.9,17.2-5.6l0.9-0.7l-6.7-7.4L221.8,85.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.9745,
    y1: 66.9612,
    x2: 241.3863,
    y2: 66.9612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M229.5,47.1c-4.1-2.5-8.7-3.7-13.7-3.7c-7,0-13.3,2.3-19,7l-0.8,0.7l6.7,7.3l0.8-0.6 c3.5-2.8,7.5-4.2,11.7-4.2c4.9,0,8.7,1.7,11.9,5.1c3.1,3.4,4.5,7.5,4.1,12.3c-0.4,4.2-2.1,8.1-5.2,11.4l-0.6,0.7l6.7,7.3l0.8-0.8 c5.2-5.2,8.1-11.4,8.6-18.4c0.5-5-0.4-9.7-2.5-14C236.7,53,233.5,49.6,229.5,47.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.1794,
    y1: 50.2107,
    x2: 289.1274,
    y2: 50.2107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "275.2,50.3 281.7,57.5 289.1,42.9 279,42.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.9554,
    y1: 71.412,
    x2: 279.9535,
    y2: 71.412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "262.1,75.1 250.9,42.9 241,42.9 255.9,87.5 260,99.9 280,60.9 273.4,53.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.0945,
    y1: 84.6214,
    x2: 301.4782,
    y2: 84.6214
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "290.1,99.1 299.7,99.1 301.5,79 292.6,70.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.9855,
    y1: 59.0081,
    x2: 304.6001,
    y2: 59.0081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "293,65.6 301.9,74.6 304.6,43.4 295,43.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.5638,
    y1: 71.3285,
    x2: 331.0643,
    y2: 71.3285
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "309.4,43.5 308.6,53.2 321.3,53.2 317.3,99.1 326.9,99.1 331.1,51.8 323.5,43.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.2187,
    y1: 48.3306,
    x2: 344.4541,
    y2: 48.3306
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "328.2,43.5 337,53.2 343.7,53.2 344.5,43.5  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "142.1,29.7 142.2,26.1 6.3,26.1 5.9,29.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.1,21 142.2,17.4 17.1,17.4 16.9,21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.1,12.3 142.2,8.7 28,8.7 27.8,12.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.1,3.6 142.2,0 38.9,0 38.7,3.6  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.1,0c2.6,0,4.7,0.9,6.4,2.7c1.7,1.8,2.4,4,2.1,6.6l-1,11.2c-0.2,2.5-1.3,4.7-3.3,6.5c-2,1.8-4.3,2.7-6.8,2.7h-9.3 L140.8,0H150.1z M144.3,24.1h3.7c1.1,0,2-0.4,2.8-1.1c0.8-0.7,1.2-1.6,1.3-2.6l1-11.2c0.1-1-0.2-1.9-0.8-2.6 c-0.7-0.7-1.5-1.1-2.6-1.1h-3.7L144.3,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.7,0l-0.5,5.5h-11.1l-0.6,6.5h11.1l-0.5,5.6h-11.1l-0.6,6.5h11.1l-0.5,5.6h-16.7L175,0H191.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5,0c2.1,0,3.7,0.7,5.1,2.2c1.3,1.5,1.9,3.2,1.7,5.2l-0.2,1.9h-5.6l0.2-1.9c0-0.5-0.1-0.9-0.4-1.3 c-0.3-0.4-0.8-0.5-1.3-0.5h-1.9c-1,0-1.9,0.4-2.7,1.1c-0.8,0.7-1.2,1.6-1.3,2.6l-0.1,0.9c0,0.5,0.1,0.9,0.4,1.3 c0.3,0.4,0.7,0.5,1.3,0.5h3.7c2.1,0,3.7,0.7,5.1,2.2c1.3,1.5,1.9,3.2,1.7,5.3l-0.1,0.9c-0.2,2.5-1.3,4.7-3.3,6.5 c-2,1.8-4.3,2.7-6.8,2.7h-1.8c-2.1,0-3.7-0.7-5.1-2.2c-1.4-1.4-1.9-3.2-1.7-5.2l0.2-1.8h5.6l-0.2,1.8c0,0.6,0.1,1,0.4,1.3 c0.3,0.4,0.7,0.5,1.3,0.5h1.8c1.1,0,2-0.4,2.8-1.1c0.8-0.7,1.2-1.6,1.3-2.6l0.1-0.9c0-0.6-0.1-1-0.4-1.4c-0.4-0.3-0.8-0.5-1.3-0.5 h-3.7c-2.1,0-3.7-0.7-5.1-2.2c-1.4-1.4-1.9-3.2-1.7-5.2l0.1-0.9c0.2-2.6,1.3-4.7,3.3-6.6c2-1.8,4.2-2.7,6.7-2.7H218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9,0c1.9,0.5,3.5,1.2,4.8,2.2c1.2,0.9,2.2,2.1,2.9,3.5c0.3,0.7,0.5,1.5,0.6,2.4c0,0.9,0.1,1.8,0,2.6l-1.7,18.9H252 l0.5-5.6h-7.4l-0.5,5.6H239l1.7-18.9c0.1-0.8,0.2-1.7,0.5-2.6c0.2-0.9,0.6-1.7,1-2.4c0.9-1.3,1.9-2.4,3.1-3.3 C246.8,1.3,248.7,0.5,250.9,0z M247.1,8c-0.5,0.8-0.7,1.7-0.8,2.7l-0.7,7.8h7.4l0.7-7.8c0.1-1.2-0.1-2.3-0.6-3.2 c-0.5-0.8-1.4-1.4-2.7-1.6C248.7,6.3,247.7,6.9,247.1,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.5,0L292,5.5h-11.1l-0.6,6.5h11.1l-0.5,5.6h-11.1l-1.1,12.1h-5.6L275.8,0H292.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.2,0h5.6l-2.6,29.7h-5.6L308.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.9,2.7c2-1.8,4.2-2.7,6.7-2.7c2.6,0,4.7,0.9,6.4,2.7c1.7,1.8,2.4,4,2.1,6.6l-1,11.2c-0.2,2.5-1.3,4.7-3.3,6.5 c-2,1.8-4.3,2.7-6.8,2.7c-2.5,0-4.6-0.9-6.3-2.7c-1.7-1.8-2.4-4-2.2-6.5l1-11.2C328.8,6.7,329.9,4.5,331.9,2.7z M340.7,6.6 c-0.7-0.7-1.5-1.1-2.6-1.1c-1,0-1.9,0.4-2.7,1.1c-0.8,0.7-1.2,1.6-1.3,2.6l-1,11.2c-0.1,1,0.2,1.9,0.9,2.6 c0.7,0.7,1.5,1.1,2.5,1.1c1.1,0,2-0.4,2.8-1.1c0.8-0.7,1.2-1.6,1.3-2.6l1-11.2C341.7,8.2,341.4,7.4,340.7,6.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.ef834428.svg";
export { ForwardRef as ReactComponent };